import { useAuth } from "../auth/AuthContext.js";

/** A top banner that warns on grace, and alarms on read-only/invalid license. */
export function LicenseBanner() {
  const { license } = useAuth();
  if (!license || license.state === "active") return null;

  const danger = license.state === "read_only" || license.state === "invalid";
  const text =
    license.reasons[0] ??
    (license.state === "grace"
      ? "License expired — in grace period. Renew soon."
      : "License invalid — the system is read-only.");

  return <div className={`banner ${danger ? "banner-danger" : "banner-warn"}`}>⚠ {text}</div>;
}
